/**
 * CreateProjectCard — A blank "+" card for the MY PROJECTS card grid.
 *
 * Matches the height and border-radius of ProjectCard (320px, 14px).
 * Navigates to /projects/new when clicked.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from '../../i18n/useAppTranslation';
import styles from './ProjectStepper.module.css';

export default function CreateProjectCard() {
  const { t } = useAppTranslation('pages');
  const navigate = useNavigate();

  return (
    <button
      className={styles.createCard}
      onClick={() => navigate('/projects/new')}
      type="button"
      title={t('stepper.createProject')}
    >
      <div className={styles.createCardIcon}>+</div>
      <span className={styles.createCardLabel}>{t('stepper.createProject')}</span>
      <span className={styles.createCardHint}>{t('stepper.createCardHint')}</span>
    </button>
  );
}
